export const themeColors = {
  theme1: {
    headerColor: "#37A8AF",
    color: "#fff",
    validateColor: "#28A745",
  },
  theme2: {
    headerColor: "#37A8AF",
    color: "#fff",
    validateColor: "#28A745",
  },
  theme3: {
    headerColor: "#346185",
    color: "#fff",
    validateColor: "#28A745",
  },
  theme4: {
    headerColor: "#37A8AF",
    color: "#fff",
    validateColor: "#28A745",
  },
  theme5: {
    headerColor: "#f56954",
    color: "#fff",
    validateColor: "#28A745",
  },
};
